<template>
  <div class="row">
  <h3>{{ article.title }}</h3>
  {{ article.content }}
  </div>
</template>

<script>

import { Dialog } from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(lang);


export default {
        components: { Dialog },
        props: ['slug'],
        data: function () {
            return {
                articleSlug: this.slug,
                article: {
                  id: null,
                  title: null,
                  content: null,
                  slug: null
                },
                dialogVisible: false
            }
        },
        computed: {
          displayWidget: function() {
            console.log(this.article.id);
            return this.article.id != null;
          }
        },
        methods: {
            fetchArticle() {
                console.log('Fetching times');
                axios.get('/api/v1/help/article/' + this.articleSlug).then((response) => {
                    // this.times = response.data;
                    console.log(response.data);
                    this.article = response.data;
                });
            },
            showDialog() {
              // Show the dialog if we have an article
              console.log('showDialog');
            console.log(this.article.id);
              if (this.article.id != null) {
                console.log('displaying dialog');
                this.dialogVisible = true;
              }
            }
        
        },
    mounted() {
        this.fetchArticle();
    }
}
</script>